import React from "react"

const Terms = () => (
  <>
    <p
      dir="ltr"
      style={{
        lineHeight: 1.7999999999999998,
        textAlign: "justify",
        marginTop: 3,
        marginBottom: 0,
      }}
    >
      <span
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        style={{
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre-wrap",
        }}
      >
        O presente contrato-padr&atilde;o estabelece as condi&ccedil;&otilde;es
        jur&iacute;dicas dos Termos e Condi&ccedil;&otilde;es de Uso da
        Plataforma Varejo Integrado (&ldquo;Termos de Uso&rdquo;) vigente na
        forma de ades&atilde;o para os Mercados e Atacadistas, conforme abaixo
        definidos, para utiliza&ccedil;&atilde;o da Plataforma desenvolvida,
        mantida e licenciada para uso de titularidade da sociedade
        empres&aacute;ria Varejo Integrado Servi&ccedil;os e Tecnologia LTDA,
        inscrita no CNPJ sob no 35.394.112/0001-59 (&ldquo;Varejo
        Integrado&rdquo;), comprometendo-se as partes aderentes a observarem as
        condi&ccedil;&otilde;es espec&iacute;ficas dispostas a seguir.
      </span>
    </p>
    <p
      dir="ltr"
      style={{
        lineHeight: 1.7999999999999998,
        textAlign: "center",
        marginTop: 3,
        marginBottom: 0,
      }}
    >
      &nbsp;
    </p>
    <p
      data-darkreader-inline-border-bottom=""
      dir="ltr"
      style={{
        lineHeight: 1.8,
        textAlign: "center",
        borderBottom: "0.5px solid rgb(0, 0, 0)",
        marginTop: 0,
        marginBottom: 0,
        padding: "3px 0px 1px",
      }}
    >
      &nbsp;
    </p>
    <p
      dir="ltr"
      style={{
        lineHeight: 1.7999999999999998,
        textAlign: "center",
        marginTop: 3,
        marginBottom: 0,
      }}
    >
      <span
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        style={{
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 700,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre-wrap",
        }}
      >
        TERMOS E CONDI&Ccedil;&Otilde;ES DE USO DA PLATAFORMA VAREJO INTEGRADO
      </span>
    </p>
    <p>
      <br />
    </p>
    <p
      dir="ltr"
      style={{
        lineHeight: 1.7999999999999998,
        textAlign: "justify",
        marginTop: 3,
        marginBottom: 0,
      }}
    >
      <span
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        style={{
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre-wrap",
        }}
      >
        Este instrumento contempla os Termos e Condi&ccedil;&otilde;es de Uso da
        plataforma de marketplace Varejo Integrado. Antes de acessar e usar a
        Plataforma, certifique-se de que compreendeu todas as
        condi&ccedil;&otilde;es estabelecidas neste instrumento. Eventuais
        d&uacute;vidas dever&atilde;o ser sanadas em contato pr&eacute;vio com a
        equipe da Varejo Integrado, por meio do e-mail:
        meajuda@mercedobairro.com. Ap&oacute;s ler e compreender todo o
        conte&uacute;do deste Termos e Condi&ccedil;&otilde;es de Uso,
        voc&ecirc; poder&aacute; aderir a ele pelo simples ato de fazer o
        primeiro uso da Plataforma. Caso voc&ecirc; n&atilde;o concorde com este
        Termos e Condi&ccedil;&otilde;es de Uso, voc&ecirc; dever&aacute;
        imediatamente suspender o uso da Plataforma. Ou seja, ao utilizar a
        Plataforma voc&ecirc; declara sua aceita&ccedil;&atilde;o integral a
        este Termos e Condi&ccedil;&otilde;es de Uso.&nbsp;
      </span>
      <span
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        style={{
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 700,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre-wrap",
        }}
      >
        A utiliza&ccedil;&atilde;o da Plataforma &eacute; considerada
        circunst&acirc;ncia que implica a aceita&ccedil;&atilde;o plena,
        irrestrita e sem reservas de todos os termos e condi&ccedil;&otilde;es
        previstos neste documento, inclusive no caso de eventuais
        revis&otilde;es ou publica&ccedil;&atilde;o de novas vers&otilde;es,
        conforme estabelece o C&oacute;digo Civil Brasileiro, art. 111.&nbsp;
      </span>
      <span
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        style={{
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre-wrap",
        }}
      >
        No caso de revis&otilde;es ou publica&ccedil;&otilde;es de novas
        vers&otilde;es, voc&ecirc; ser&aacute; avisado previamente e, caso
        n&atilde;o concorde com as altera&ccedil;&otilde;es, dever&aacute;
        descontinuar o uso da Plataforma. O uso continuado da Plataforma,
        ap&oacute;s a revis&atilde;o dos Termos e Condi&ccedil;&otilde;es de
        Uso, implica aceita&ccedil;&atilde;o das altera&ccedil;&otilde;es, sem
        ressalvas.
      </span>
    </p>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -18,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            DEFINI&Ccedil;&Otilde;ES
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Defini&ccedil;&otilde;es
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Os termos iniciados em letra mai&uacute;scula indicados a seguir
            ser&atilde;o utilizados com o significado detalhado abaixo:
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &ldquo;Atacadista&rdquo;:
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;&eacute; o comerciante de atacado, distribuidor ou
            ind&uacute;stria de alimentos ou bebidas que utiliza a Plataforma
            para vender e distribuir produtos aos Mercados cadastrados na
            Plataforma.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="2"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &ldquo;Mercado&rdquo;:
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;&eacute; o estabelecimento comercial que utiliza a Plataforma
            para adquirir, para revenda, alimentos, bebidas e outros produtos
            dos Atacadistas cadastrados na Plataforma.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="3"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &ldquo;Plataforma&rdquo;:
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;&eacute; a ferramenta de intermedia&ccedil;&atilde;o de
            neg&oacute;cios constitu&iacute;da por uma aplica&ccedil;&atilde;o
            de web software de responsabilidade, propriedade e
            opera&ccedil;&atilde;o da Varejo Integrado. A Plataforma tem por
            finalidade promover a intermedia&ccedil;&atilde;o de neg&oacute;cios
            entre os Mercados, de um lado, e os Atacadistas, de outro lado.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="4"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &ldquo;Pol&iacute;tica de Privacidade&rdquo;:
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;&eacute; o conjunto de regras que disciplina a coleta e a
            utiliza&ccedil;&atilde;o de dados pessoais dos Usu&aacute;rios.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="5"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &ldquo;Termos de Uso&rdquo;:
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;&eacute; este instrumento, que disciplina os termos e as
            condi&ccedil;&otilde;es gerais que reger&atilde;o o acesso e o uso
            da Plataforma pelos Usu&aacute;rios. A Varejo Integrado
            poder&aacute; estabelecer Termos de Uso espec&iacute;ficos e
            aplic&aacute;veis a determinados produtos ou funcionalidades,
            conforme o caso, que complementar&atilde;o e prevalecer&atilde;o
            sobre este Termos de Uso.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="6"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &ldquo;Usu&aacute;rio&rdquo;:
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;s&atilde;o os Atacadistas e Mercados cadastrados na
            Plataforma. Os Usu&aacute;rios podem ser tanto pessoas
            f&iacute;sicas como jur&iacute;dicas. Os Usu&aacute;rios s&atilde;o
            identificados e qualificados no momento de preenchimento do
            formul&aacute;rio para acesso e uso da Plataforma.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="7"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &ldquo;Varejo Integrado&rdquo;:
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;&eacute; Varejo Integrado Servi&ccedil;os e Tecnologia Ltda.,
            inscrita no CNPJ sob o n.&ordm; 35.394.112/0001-59.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="2"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -18,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Objeto
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Objeto
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Este Termos de Uso tem por objeto disciplinar os termos e as
            condi&ccedil;&otilde;es gerais que reger&atilde;o o acesso e o uso
            da Plataforma pelos Usu&aacute;rios.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="3"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -18,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            CADASTRO DE USU&Aacute;RIOS
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Informa&ccedil;&otilde;es cadastrais
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Para utilizar as funcionalidades disponibilizadas pela Plataforma,
            o Usu&aacute;rio deve fornecer informa&ccedil;&otilde;es
            espec&iacute;ficas a respeito de si e/ou da pessoa f&iacute;sica ou
            jur&iacute;dica que representa. Ao aderir a este Termos de Uso, o
            Usu&aacute;rio declara e garante que forneceu e sempre
            fornecer&aacute; &agrave; Varejo Integrado informa&ccedil;&otilde;es
            exatas, atualizadas e verdadeiras. O Usu&aacute;rio se declara
            ciente de que a utiliza&ccedil;&atilde;o de dados falsos,
            desatualizados, inv&aacute;lidos, incorretos ou de terceiros
            poder&aacute; acarretar o t&eacute;rmino antecipado da
            vig&ecirc;ncia deste Termos de Uso, com o consequente impedimento da
            utiliza&ccedil;&atilde;o, pelo Usu&aacute;rio, da Plataforma, sem
            preju&iacute;zo de responsabiliza&ccedil;&atilde;o civil e criminal
            do Usu&aacute;rio, bem como do pagamento de
            indeniza&ccedil;&atilde;o por perdas e danos sofridos pela Varejo
            Integrado e seus parceiros comerciais.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="3"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: 10.35,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Atualiza&ccedil;&atilde;o de informa&ccedil;&otilde;es cadastrais
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . O Usu&aacute;rio se obriga a manter atualizadas todas as
            informa&ccedil;&otilde;es cadastrais a seu respeito, devendo atender
            prontamente quaisquer solicita&ccedil;&otilde;es referentes &agrave;
            atualiza&ccedil;&atilde;o cadastral, sob pena de suspens&atilde;o ou
            cancelamento de seu cadastro, sem que tal suspens&atilde;o ou
            cancelamento gere ao Usu&aacute;rio qualquer direito de
            indeniza&ccedil;&atilde;o ou reembolso.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="2"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="3"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: 10.35,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Consulta a bancos de dados de terceiros.
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;A Varejo Integrado e qualquer de seus parceiros comerciais
            poder&atilde;o realizar pesquisas, em base de dados p&uacute;blicas
            ou privadas, com a finalidade de verificar a veracidade dos dados e
            informa&ccedil;&otilde;es indicados pelos Usu&aacute;rios, bem como
            compartilhar com as institui&ccedil;&otilde;es financeiras
            envolvidas nas transa&ccedil;&otilde;es os dados do Usu&aacute;rio
            para possibilitar a presta&ccedil;&atilde;o dos servi&ccedil;os da
            Plataforma e o atendimento &agrave;s normas e
            regula&ccedil;&atilde;o em vigor, com o que o Usu&aacute;rio, desde
            j&aacute;, concorda e, expressamente, autoriza.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="3"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="3"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: 10.35,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Bloqueio do acesso por inconsist&ecirc;ncia em
            informa&ccedil;&otilde;es cadastrais.
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;O Usu&aacute;rio reconhece e aceita que nas hip&oacute;teses
            de (a) a Varejo Integrado constatar a exist&ecirc;ncia de
            informa&ccedil;&otilde;es cadastrais incorretas, inver&iacute;dicas,
            desatualizadas ou inexatas, e/ou de (b) o Usu&aacute;rio n&atilde;o
            disponibilizar informa&ccedil;&otilde;es e/ou documentos
            eventualmente requeridos pela Varejo Integrado, a Varejo Integrado
            poder&aacute;, a seu crit&eacute;rio exclusivo e
            discricion&aacute;rio, bloquear por tempo indeterminado o cadastro
            do Usu&aacute;rio. Em decorr&ecirc;ncia do bloqueio cadastral, o
            Usu&aacute;rio estar&aacute; temporariamente impedido de acessar e
            utilizar as funcionalidades da Plataforma, sem que nenhuma
            responsabilidade possa ser imputada a Varejo Integrado a esse
            respeito.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="2"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Aus&ecirc;ncia de impedimentos para ades&atilde;o a este Termos de
            Uso
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Ao aderir a este Termos de Uso, o Usu&aacute;rio declara
            n&atilde;o ter nenhum impedimento para efetuar seu cadastro e
            acessar a Plataforma, inexistindo contrato ou v&iacute;nculo de
            qualquer natureza com terceiros ou qualquer decis&atilde;o ou
            restri&ccedil;&atilde;o imposta por uma autoridade governamental ou
            judici&aacute;ria que de qualquer forma o impe&ccedil;a de aderir a
            este Termos de Uso. O Usu&aacute;rio declara possuir capacidade
            jur&iacute;dica para contrata&ccedil;&atilde;o da Plataforma, bem
            como se obriga pelo pagamento de todos os valores atribu&iacute;dos
            &agrave; pessoa f&iacute;sica ou jur&iacute;dica em nome da qual
            ocorreu a contrata&ccedil;&atilde;o. Caso o Usu&aacute;rio venha a
            realizar contrata&ccedil;&atilde;o em nome de pessoa f&iacute;sica
            ou jur&iacute;dica para a qual n&atilde;o possua capacidade de
            representa&ccedil;&atilde;o, o Usu&aacute;rio estar&aacute;
            pessoalmente respons&aacute;vel &agrave;s obriga&ccedil;&otilde;es
            deste instrumento, incluindo o pagamento dos servi&ccedil;os
            fornecidos pela Varejo Integrado.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="3"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Sigilo das credenciais de acesso &agrave; Plataforma
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . O Usu&aacute;rio &eacute; respons&aacute;vel por manter em sigilo
            as credenciais de acesso &agrave; Plataforma (nome de
            usu&aacute;rio, senha, pergunta secreta, entre outros), assumindo a
            responsabilidade de n&atilde;o compartilhar com terceiros as suas
            informa&ccedil;&otilde;es de acesso. Caso o acesso &agrave;
            Plataforma seja efetuado por terceiros n&atilde;o autorizados em
            raz&atilde;o de neglig&ecirc;ncia ou imprud&ecirc;ncia do
            Usu&aacute;rio, ou ainda em decorr&ecirc;ncia de culpa exclusiva ou
            concorrente do Usu&aacute;rio, a Varejo Integrado estar&aacute;
            isenta de qualquer responsabilidade relacionada &agrave; privacidade
            e seguran&ccedil;a das informa&ccedil;&otilde;es e arquivos do
            Usu&aacute;rio. O Usu&aacute;rio n&atilde;o poder&aacute;
            compartilhar, dividir ou fornecer suas credenciais de acesso para
            utiliza&ccedil;&atilde;o de terceiros, sob pena de cancelamento da
            conta e t&eacute;rmino da rela&ccedil;&atilde;o contratual com a
            Varejo Integrado, al&eacute;m da elimina&ccedil;&atilde;o de todas
            as informa&ccedil;&otilde;es e arquivos armazenados na Plataforma. O
            Usu&aacute;rio &eacute; obrigado a comunicar &agrave; Varejo
            Integrado a respeito de eventual extravio ou aliena&ccedil;&atilde;o
            das informa&ccedil;&otilde;es de acesso &agrave; conta, observado
            que a Varejo Integrado n&atilde;o se responsabiliza pela
            seguran&ccedil;a e privacidade das informa&ccedil;&otilde;es do
            Usu&aacute;rio em caso de uso ou compartilhamento negligente ou
            imprudente das informa&ccedil;&otilde;es de acesso.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="4"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Comunica&ccedil;&atilde;o com o Usu&aacute;rio
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . O Usu&aacute;rio declara que o e-mail informado &agrave; Varejo
            Integrado por meio do registro na Plataforma &eacute; uma forma de
            comunica&ccedil;&atilde;o eficaz, v&aacute;lida e suficiente para
            recebimento de comunicados relacionados &agrave; sua conta, bem como
            para informa&ccedil;&otilde;es de cancelamento ou suspens&atilde;o
            de uso da Plataforma. O Usu&aacute;rio reconhece e autoriza
            tamb&eacute;m a utiliza&ccedil;&atilde;o da p&aacute;gina inicial de
            acesso &agrave; Plataforma como meio v&aacute;lido e suficiente para
            a divulga&ccedil;&atilde;o de assuntos relacionados &agrave;
            Plataforma, inclusive em rela&ccedil;&atilde;o a eventual reajuste
            de pre&ccedil;os ou altera&ccedil;&atilde;o de funcionalidades.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="4"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -18,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            USO DA PLATAFORMA
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Uso da Plataforma
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Ao aderir a este Termos de Uso, o Usu&aacute;rio ter&aacute;
            acesso &agrave;s funcionalidades da Plataforma conforme o tipo de
            conta criada no momento de registro na Plataforma (Atacadista ou
            Mercado).
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="2"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Condutas proibidas na utiliza&ccedil;&atilde;o da Plataforma
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . O Usu&aacute;rio se obriga a utilizar a Plataforma de
            boa-f&eacute; e sem a inten&ccedil;&atilde;o de praticar atos
            il&iacute;citos ou causar danos a terceiros. Sem preju&iacute;zo ou
            limita&ccedil;&atilde;o &agrave;s demais obriga&ccedil;&otilde;es e
            restri&ccedil;&otilde;es previstas neste Termos de Uso e na
            legisla&ccedil;&atilde;o pertinente, o Usu&aacute;rio obriga-se a
            n&atilde;o praticar e a fazer com que quaisquer pessoas autorizadas
            que tenham acesso &agrave; Plataforma n&atilde;o pratiquem nenhuma
            das seguintes condutas:
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            distribuir, reproduzir, modificar, vender, alugar ou de qualquer
            forma explorar economicamente a Plataforma, seus dados,
            informa&ccedil;&otilde;es, c&oacute;digo-fonte, marcas, direitos
            autorais relacionados, ou qualquer outro conte&uacute;do veiculado
            pela Varejo Integrado;
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="2"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            realizar quaisquer modifica&ccedil;&otilde;es, melhoramentos,
            adapta&ccedil;&otilde;es, obras derivadas ou tradu&ccedil;&otilde;es
            da Plataforma;
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="3"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            decifrar, decodificar, desmontar, realizar engenharia reversa, ou
            tentar deduzir qualquer parte do c&oacute;digo-fonte, ideia
            subjacente ou algoritmos relacionados &agrave; Plataforma;
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="4"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            investigar ou testar a vulnerabilidade de qualquer sistema ou rede
            relacionada &agrave; Plataforma;
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="5"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            acessar, adulterar ou usar &aacute;reas n&atilde;o p&uacute;blicas
            da Plataforma ou quaisquer &aacute;reas compartilhadas para as quais
            o Usu&aacute;rio n&atilde;o possui autoriza&ccedil;&atilde;o de
            acesso;
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="6"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            causar danos, interferir ou perturbar outros Usu&aacute;rios e/ou
            servidores de hospedagem ou rede;
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="7"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            corromper, danificar, limitar ou interferir na fun&ccedil;&atilde;o
            apropriada e normal de softwares, hardwares, ferramentas ou
            equipamentos relacionados &agrave; Plataforma;
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="8"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            obter acesso n&atilde;o autorizado a sistemas,
            informa&ccedil;&otilde;es, senhas, ou outros dados da Varejo
            Integrado e/ou de quaisquer Usu&aacute;rios ou terceiros;
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="9"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "rgb(255, 255, 255)",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            interferir no funcionamento normal da Plataforma, incluindo por meio
            de envio ou transmiss&atilde;o de qualquer arquivo malicioso que
            contenha v&iacute;rus, worms, cavalos de Tr&oacute;ia ou qualquer
            outra esp&eacute;cie de programa&ccedil;&atilde;o ou comando que
            possa contaminar, destruir ou interferir no bom funcionamento da
            Plataforma;
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="10"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            violar ou contornar medidas de seguran&ccedil;a e/ou
            autentica&ccedil;&atilde;o da Varejo Integrado para restringir ou
            prevenir o acesso a ferramentas, contas, sistemas e redes
            relacionadas &agrave; Plataforma; e
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="11"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            utilizar os servi&ccedil;os contratados para fins de
            infra&ccedil;&atilde;o &agrave; legisla&ccedil;&atilde;o brasileira,
            para fins de causar danos a terceiros ou para fins de armazenar
            documentos que estejam relacionados a il&iacute;citos c&iacute;veis
            ou penais.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="3"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Acesso &agrave; Plataforma
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . A Plataforma &eacute; disponibilizada atrav&eacute;s da rede
            mundial de computadores, sendo de inteira responsabilidade do
            Usu&aacute;rio o dispositivo pelo qual realiza o acesso, bem como
            sua conex&atilde;o pr&oacute;pria com a internet, englobando,
            provedor de acesso, modem, e demais intermedi&aacute;rios envolvidos
            na conex&atilde;o particular do Usu&aacute;rio. A Varejo Integrado
            n&atilde;o possui qualquer obriga&ccedil;&atilde;o sobre os
            dispositivos e conex&otilde;es particulares do Usu&aacute;rio. O
            Usu&aacute;rio assume a obriga&ccedil;&atilde;o de n&atilde;o
            acessar a Plataforma atrav&eacute;s de conex&atilde;o indireta aos
            servidores da Varejo Integrado, n&atilde;o podendo fazer uso de
            tecnologias de proxy ou&nbsp;
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "italic",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            virtual private network
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "italic",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            (VPN)
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;ou qualquer outra tecnologia que impe&ccedil;a o completo
            conhecimento por parte da Varejo Integrado do n&uacute;mero de&nbsp;
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "italic",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            IP (Internet Protocol)
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;utilizado na conex&atilde;o, ou que mostre n&uacute;mero de IP
            diferente do computador de origem do acesso, sob pena de
            cancelamento do acesso &agrave; Plataforma por
            viola&ccedil;&atilde;o &agrave;s regras de seguran&ccedil;a dos
            servidores da Varejo Integrado. O Usu&aacute;rio &eacute;
            respons&aacute;vel por realizar o acesso &agrave; Plataforma apenas
            em computadores seguros e privados, que estejam livres de
            v&iacute;rus e que sejam confi&aacute;veis do ponto de vista de
            seguran&ccedil;a dos dados inseridos, n&atilde;o havendo
            responsabilidade da Varejo Integrado por qualquer forma de
            indeniza&ccedil;&atilde;o em raz&atilde;o de acesso em computadores
            p&uacute;blicos, como, por exemplo, em&nbsp;
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "italic",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            lan houses
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            .
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="4"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Administra&ccedil;&atilde;o da Plataforma
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Na qualidade de desenvolvedora e administradora da Plataforma, a
            Varejo Integrado ter&aacute; poderes e poder&aacute;: (a) permitir
            que os Mercados manifestem sua opini&atilde;o a respeito da
            qualidade dos produtos comercializados pelos Atacadistas; (b)
            analisar as reclama&ccedil;&otilde;es dos Usu&aacute;rios da
            Plataforma e entrar em contato com os Usu&aacute;rios para
            resolu&ccedil;&atilde;o de eventuais d&uacute;vidas ou conflitos;
            (c) estabelecer condi&ccedil;&otilde;es m&iacute;nimas para o
            fornecimento de produtos e servi&ccedil;os por meio da Plataforma;
            (d) estabelecer planos e condi&ccedil;&otilde;es de cobran&ccedil;a
            diferenciadas para determinados Usu&aacute;rios ou parceiros da
            Plataforma; e (e) estabelecer rela&ccedil;&atilde;o contratual com
            terceiros (tais como empresas de meio de pagamento, servi&ccedil;os
            de publicidade, servi&ccedil;os de comunica&ccedil;&atilde;o,
            transportadoras, entre outros) e agregar os seus produtos e
            servi&ccedil;os &agrave; Plataforma com o objetivo de viabilizar e
            operacionalizar a presta&ccedil;&atilde;o dos servi&ccedil;os de
            intermedia&ccedil;&atilde;o de neg&oacute;cios.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="5"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -18,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            DISPONIBILIDADE E MANUTEN&Ccedil;&Atilde;O DA PLATAFORMA
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Disponibilidade da Plataforma
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . A Varejo Integrado envidar&aacute; os seus melhores
            esfor&ccedil;os para que a Plataforma opere continuamente,
            por&eacute;m n&atilde;o garante ou assume responsabilidade pelo uso
            da Plataforma livre de erros e de forma cont&iacute;nua e
            ininterrupta. Os per&iacute;odos de funcionamento afetados por
            manuten&ccedil;&otilde;es programadas, manuten&ccedil;&otilde;es
            preventivas, falta de energia el&eacute;trica,
            interrup&ccedil;&atilde;o ou suspens&atilde;o da
            presta&ccedil;&atilde;o dos servi&ccedil;os de
            telecomunica&ccedil;&otilde;es, ocorr&ecirc;ncias de falhas no
            sistema de transmiss&atilde;o ou roteamento no acesso &agrave;
            internet, atualiza&ccedil;&otilde;es do sistema, ou casos fortuitos
            e de for&ccedil;a maior, estar&atilde;o exclu&iacute;dos do tempo de
            opera&ccedil;&atilde;o e n&atilde;o configurar&atilde;o qualquer
            tipo de responsabilidade ou obriga&ccedil;&atilde;o de indenizar
            para a Varejo Integrado. Em caso de manuten&ccedil;&otilde;es
            urgentes, a Varejo Integrado envidar&aacute; seus melhores
            esfor&ccedil;os para comunicar os Usu&aacute;rios a respeito da
            poss&iacute;vel suspens&atilde;o ou interrup&ccedil;&atilde;o dos
            servi&ccedil;os com anteced&ecirc;ncia razo&aacute;vel para
            n&atilde;o prejudicar as atividades do Usu&aacute;rio.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="2"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Assist&ecirc;ncia t&eacute;cnica
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . A Varejo oferecer&aacute; aos Usu&aacute;rios assist&ecirc;ncia
            t&eacute;cnica relacionada a falhas e defeitos do funcionamento da
            Plataforma, mas n&atilde;o ser&aacute; respons&aacute;vel pela
            opera&ccedil;&atilde;o individual dos dispositivos do
            Usu&aacute;rio.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="3"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Atualiza&ccedil;&otilde;es
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . O Usu&aacute;rio dever&aacute; manter a Plataforma sempre
            atualizada, realizando todas as atualiza&ccedil;&otilde;es sugeridas
            ou enviadas pela Varejo Integrado de tempos em tempos. A Varejo
            Integrado n&atilde;o responder&aacute; por eventuais perdas e danos
            causados ao Usu&aacute;rio quando o Usu&aacute;rio n&atilde;o
            estiver utilizando a &uacute;ltima vers&atilde;o dispon&iacute;vel
            da Plataforma.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="4"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Suspens&atilde;o de uso da Plataforma
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . A Varejo Integrado se reserva o direito de suspender o acesso do
            Usu&aacute;rio sem notifica&ccedil;&atilde;o pr&eacute;via caso seja
            verificado mau uso, causado por volume muito acima de m&eacute;dias
            ou opera&ccedil;&otilde;es consideradas inapropriadas para o bom uso
            e seguran&ccedil;a da Plataforma, ou em qualquer outro caso de
            descumprimento das cl&aacute;usulas deste Termos de Uso, inclusive,
            mas n&atilde;o se limitando a, inadimplemento de quantias devidas
            &agrave; Varejo Integrado e uso indevido de marcas e sinais
            distintivos n&atilde;o licenciados ao Usu&aacute;rio.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="5"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Descontinuidade da Plataforma
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . A Varejo Integrado poder&aacute;, a seu crit&eacute;rio,
            suspender, interromper, modificar ou descontinuar a Plataforma, a
            qualquer tempo, conforme lhe convier, ainda que fora das
            hip&oacute;teses previstas neste Termos de Uso, desde que mediante
            aviso pr&eacute;vio com prazo razo&aacute;vel aos Usu&aacute;rios,
            sem que isso configure nenhum tipo de responsabilidade para a Varejo
            Integrado.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="6"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 700,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -18,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            COMERCIALIZA&Ccedil;&Atilde;O DE PRODUTOS E OBRIGA&Ccedil;&Otilde;ES
            DOS ATACADISTAS, DOS MERCADOS E DA VAREJO INTEGRADO
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Recebimento e repasse dos pedidos dos Mercados para os Atacadistas
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Caber&aacute; &agrave; Varejo Integrado, por meio da Plataforma
            e/ou de qualquer outra estrutura e rotina organizacional e
            tecnol&oacute;gica que venha a ser estabelecida, receber os pedidos
            de compra dos Mercados e repass&aacute;-los para os Atacadistas.
            Dentro do prazo estabelecido na Plataforma, ou acordado de comum
            acordo entre a Varejo Integrado e os Atacadistas, o Atacadista
            dever&aacute; informar se aceita ou n&atilde;o realizar e entregar o
            pedido realizado pelo Mercado. Caso o Atacadista aceite, o pedido do
            Mercado dever&aacute; ser realizado em conformidade com as
            condi&ccedil;&otilde;es descritas no formul&aacute;rio de
            solicita&ccedil;&atilde;o.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="2"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Registro e atualiza&ccedil;&atilde;o de produtos comercializados por
            meio da Plataforma
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Os Atacadistas dever&atilde;o manter sempre atualizados o rol de
            produtos e quantidades dispon&iacute;veis para
            comercializa&ccedil;&atilde;o e distribui&ccedil;&atilde;o aos
            Mercados que utilizam a Plataforma, obrigando-se a aderir a
            eventuais APIs e sistemas eletr&ocirc;nicos de
            integra&ccedil;&atilde;o e acompanhamento em tempo real que venham a
            ser desenvolvidos e sejam oferecidos pela Varejo Integrado.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="3"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: 10.35,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Responsabilidade pela venda de produtos com
            informa&ccedil;&otilde;es desatualizadas
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Em caso de verifica&ccedil;&atilde;o de discrep&acirc;ncias na
            quantidade e disponibilidade de produtos ou em seus pre&ccedil;os, o
            Atacadista dever&aacute; realizar a venda com base na &uacute;ltima
            quantidade, disponibilidade e pre&ccedil;o informada ao Mercado pelo
            Atacadista por meio da Plataforma para a realiza&ccedil;&atilde;o da
            venda, ainda que isso gere eventuais diferen&ccedil;as de
            pre&ccedil;os e/ou preju&iacute;zos para o Atacadista. Caso
            determinada venda venha a ser conclu&iacute;da com a
            utiliza&ccedil;&atilde;o de informa&ccedil;&otilde;es desatualizadas
            por parte do Atacadista, o Atacadista ser&aacute; o &uacute;nico e
            exclusivo respons&aacute;vel por indenizar todas as perdas e danos
            eventualmente sofridos pela Varejo Integrado ou pelos Mercados,
            devendo, ainda, arcar com qualquer varia&ccedil;&atilde;o de
            pre&ccedil;o que venha a ser incorrida para entrega dos produtos aos
            Mercados em raz&atilde;o da falta de atualiza&ccedil;&atilde;o de
            informa&ccedil;&otilde;es a respeito de seu estoque e
            disponibilidade dos produtos publicados na Plataforma.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="3"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: " rgb(255, 255, 255)",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Processamento dos pedidos realizados pelos Mercados na Plataforma.
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "rgb(255, 255, 255)",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;Uma vez recebido e aceito um pedido formulado por um Mercado,
            o Atacadista dever&aacute; executar, preparar e providenciar o
            pedido fazendo uso das melhores pr&aacute;ticas de sua &aacute;rea
            de atua&ccedil;&atilde;o e levando em considera&ccedil;&atilde;o
            todos os eventuais coment&aacute;rios ou instru&ccedil;&otilde;es
            transmitidos pelo Mercado ou pela Varejo Integrado.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="4"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Entrega dos produtos (modalidade de delivery
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            ). Caso o Atacadista venha a assumir a responsabilidade pela entrega
            dos produtos comercializados por meio da Plataforma, ainda que a
            entrega seja realizada por meio de subcontratados do Atacadista, o
            Atacadista dever&aacute; observar e garantir o seguinte:
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            O Atacadista, ou o transportador contratado pelo Atacadista para a
            realiza&ccedil;&atilde;o da entrega, dever&aacute; possuir todas as
            autoriza&ccedil;&otilde;es e documentos necess&aacute;rios para
            atuar na atividade de transporte e entrega de produtos, conforme o
            disposto na legisla&ccedil;&atilde;o aplic&aacute;vel;
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="2"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Os produtos dever&atilde;o ser entregues no endere&ccedil;o e no
            prazo acordados com o Mercado por meio do aceite do pedido feito
            pelo Mercado por meio da Plataforma, sendo o Atacadista o
            &uacute;nico e exclusivo respons&aacute;vel por eventuais perdas,
            avarias, erros e/ou atrasos causados, devendo inclusive manter a
            Varejo Integrado, seus s&oacute;cios, administradores e
            colaboradores indenes a esse respeito;
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="3"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Os produtos devem ser embalados e transportados de forma segura e
            adequada, de modo que o Mercado receba os produtos em perfeito
            estado de conserva&ccedil;&atilde;o, em conformidade com as mesmas
            caracter&iacute;sticas anunciadas na Plataforma; e
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="4"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Caso o Atacadista venha a se comunicar diretamente com os Mercados a
            respeito do transporte e entrega dos produtos, ou qualquer outro
            assunto, o Atacadista dever&aacute; agir sempre de maneira
            respeitosa, polida e prestativa, de acordo com as melhores
            pr&aacute;ticas do mercado.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="5"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Entrega dos produtos (modalidade de pick-up)
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Caso o Mercado tenha optado por buscar os produtos diretamente no
            estabelecimento comercial do Atacadista, ou caso a Varejo Integrado
            venha a realizar os servi&ccedil;os de organiza&ccedil;&atilde;o e
            sele&ccedil;&atilde;o, retirada e/ou entrega dos produtos em
            benef&iacute;cio dos Mercados, o Atacadista dever&aacute; garantir
            acesso ao seu estabelecimento comercial e, se for o caso,
            disponibilizar os produtos de forma organizada para retirada em seu
            estabelecimento comercial, observado o prazo para
            prepara&ccedil;&atilde;o do pedido e o hor&aacute;rio de
            funcionamento informado por ocasi&atilde;o do aceite do pedido. Na
            modalidade de entrega por pick-up o Atacadista tamb&eacute;m
            dever&aacute; observar as obriga&ccedil;&otilde;es previstas nos
            itens&nbsp;
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            (b)
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;a&nbsp;
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            (d)
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;da Cl&aacute;usula&nbsp;
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            6
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            .
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            4
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;acima.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="6"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Devolu&ccedil;&atilde;o e troca de produtos com defeitos
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Os Atacadistas reconhecem que, nos termos da
            legisla&ccedil;&atilde;o aplic&aacute;vel, os Mercados ter&atilde;o
            o direito de solicitar a troca e/ou devolu&ccedil;&atilde;o dos
            produtos que apresentarem defeitos ou desconformidades. Os Mercados
            dever&atilde;o recusar os produtos que apresentarem defeitos ou
            desconformidades no ato de recebimento. Nesse caso, os Atacadistas
            assumem a obriga&ccedil;&atilde;o de realizar a troca dos produtos
            que estiverem com defeitos e/ou desconformidades, sem qualquer custo
            ou &ocirc;nus adicional para os Mercados. Caso n&atilde;o seja
            poss&iacute;vel realizar a troca dos produtos por qualquer motivo,
            inclusive por falta de estoque, o Atacadista dever&aacute; restituir
            ao Mercado o valor dos produtos em quest&atilde;o, inclusive o
            frete, caso a devolu&ccedil;&atilde;o dos valores pagos tenha sido
            solicitada. Os Mercados reconhecem que, nesse caso, a Varejo
            Integrado atuar&aacute; como intermediadora para que os Atacadistas,
            que s&atilde;o os &uacute;nicos e exclusivos respons&aacute;veis
            pelo fornecimento dos produtos, realizem a troca dos produtos
            defeituosos, nada podendo ser imputado &agrave; Varejo Integrado a
            esse respeito.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="7"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Nota fiscal de venda dos produtos
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Os Atacadistas dever&atilde;o emitir e providenciar a entrega da
            nota fiscal, recibo ou documento equivalente de venda para os
            Mercados, em rela&ccedil;&atilde;o aos pedidos por eles solicitados
            e aceitos e realizados pelos Atacadistas. Na medida em que a Varejo
            Integrado atua apenas como intermediadora de neg&oacute;cios,
            nenhuma responsabilidade ou obriga&ccedil;&atilde;o a esse respeito
            poder&aacute; ser-lhe imputada pelos Atacadistas e/ou pelos
            Mercados, a qualquer t&iacute;tulo, a qualquer tempo.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="8"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Recebimento e repasse do valor de venda dos produtos
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Caber&aacute; &agrave; Varejo Integrado, por meio da Plataforma
            e/ou de qualquer outra estrutura e rotina organizacional e
            tecnol&oacute;gica que venha a ser estabelecida, a
            atribui&ccedil;&atilde;o de cobrar e receber dos Mercados, por conta
            e ordem dos Atacadistas, o valor total da venda dos produtos que
            venham a ser realizadas por meio da Plataforma. A Varejo Integrado
            dever&aacute; repassar para os Atacadistas, no prazo previsto na
            Plataforma ou acordado de comum acordo, o valor devido aos
            Atacadistas pela venda, fazendo o devido desconto e
            compensa&ccedil;&atilde;o da comiss&atilde;o que lhe cabe e de
            eventuais taxas e penalidades que sejam devidas pelo Atacadista.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="9"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Pagamento do valor de venda dos produtos.
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;Os Mercados dever&atilde;o realizar o pagamento dos produtos
            adquiridos por meio da Plataforma, por meio de boleto
            banc&aacute;rio, transfer&ecirc;ncia de recursos, cart&atilde;o de
            cr&eacute;dito ou qualquer outra forma que venha a ser
            disponibilizada pela Varejo Integrado. O pagamento com cart&atilde;o
            de cr&eacute;dito estar&aacute; sujeito &agrave;
            avalia&ccedil;&atilde;o e aprova&ccedil;&atilde;o da
            institui&ccedil;&atilde;o de pagamento respons&aacute;vel. Em caso
            de atraso no pagamento, o Mercado ficar&aacute; sujeito ao pagamento
            das penalidades previstas na Cl&aacute;usula&nbsp;
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            12.2
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            .
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="10"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Pagamento e apoio operacional ap&oacute;s os pedidos
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Ao realizar qualquer pedido de fornecimento ou
            disponibiliza&ccedil;&atilde;o de oferta de produtos na Plataforma,
            o Usu&aacute;rio concorda que a Varejo Integrado poder&aacute;
            executar suas ordens de organiza&ccedil;&atilde;o, preparo, compra
            ou venda em nome de terceiro, coleta ou entrega de bens, bem como
            pagamentos, adiantamentos, recebimentos, transfer&ecirc;ncias e
            resgate de recursos especificados para a pr&aacute;tica de quaisquer
            atos necess&aacute;rios &agrave; presta&ccedil;&atilde;o dos
            servi&ccedil;os contratados.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="3"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: 10.35,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Opera&ccedil;&atilde;o em nome de terceiro
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . O Usu&aacute;rio responsabiliza-se pelos eventuais reembolsos de
            adiantamento e pagamentos dos pre&ccedil;os referentes aos pedidos
            emanados das credenciais de acesso &agrave; Plataforma de sua
            titularidade, comprometendo-se &agrave; assinatura de
            confiss&atilde;o de d&iacute;vida no ato da entrega dos produtos ou,
            desde j&aacute;, autorizando a extra&ccedil;&atilde;o de
            t&iacute;tulo de cr&eacute;dito e protesto dos valores
            reembols&aacute;veis pela Varejo Integrado, nos termos da
            Cl&aacute;usula 10.2.1.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="2"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="3"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: 10.35,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Agente
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Em nenhuma hip&oacute;tese a Varejo Integrado poder&aacute; ser
            considerada revendedora dos bens ou servi&ccedil;os publicados em
            sua Plataforma, devendo ser sempre considerada &ldquo;agente&rdquo;,
            nos termos do IFRS 15/CPC 47, cabendo-lhe, exclusivamente,
            providenciar o fornecimento de bens ou servi&ccedil;os especificados
            pelo Usu&aacute;rio. Em nenhuma hip&oacute;tese a Varejo Integrado
            ser&aacute; considerada como entidade que controla os bens ou os
            servi&ccedil;os especificados a serem fornecidos ao Mercado.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="7"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -18,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            PROPRIEDADE INTELECTUAL
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Aus&ecirc;ncia de transfer&ecirc;ncia de direitos de propriedade
            intelectual
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Os Usu&aacute;rios reconhecem e aceitam que este Termos de Uso e a
            utiliza&ccedil;&atilde;o da Plataforma n&atilde;o lhe conferem
            nenhum direito, incluindo, mas n&atilde;o se limitando a direitos
            autorais e/ou direitos de propriedade industrial sobre a Plataforma
            e/ou qualquer funcionalidade ou servi&ccedil;o disponibilizado por
            meio da Plataforma, bem como sobre todos e quaisquer materiais e
            conte&uacute;dos de qualquer natureza que digam respeito e/ou
            estejam relacionados &agrave; Plataforma ou &agrave; Varejo
            Integrado e seus parceiros comerciais e subcontratados, incluindo
            marcas, sinais distintivos, logotipos, imagens, sons, fotografias,
            documentos, textos ou quaisquer outros elementos disponibilizados na
            Plataforma. Os Usu&aacute;rios reconhecem e aceitam ainda que
            est&atilde;o proibidos de fazer uso ou de permitir que terceiros
            fa&ccedil;am uso de tais materiais, conte&uacute;dos e de quaisquer
            direitos autorais e/ou direitos de propriedade industrial de
            titularidade da Varejo Integrado ou de qualquer terceiro que tenha
            licenciado tais direitos &agrave; Varejo Integrado, sem
            pr&eacute;via e expressa autoriza&ccedil;&atilde;o do respectivo
            titular. Por consequ&ecirc;ncia, os Usu&aacute;rios declaram-se
            cientes de que o uso indevido e a reprodu&ccedil;&atilde;o total ou
            parcial dos referidos conte&uacute;dos e ferramentas s&atilde;o
            proibidos, salvo mediante autoriza&ccedil;&atilde;o pr&eacute;via e
            expressa do respectivo titular.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="2"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Autoriza&ccedil;&atilde;o de uso prec&aacute;rio
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Os Usu&aacute;rios entendem e aceitam que a
            autoriza&ccedil;&atilde;o de uso da Plataforma e de suas
            funcionalidades e ferramentas n&atilde;o poder&aacute; ser
            compreendida como cess&atilde;o ou atribui&ccedil;&atilde;o de
            direitos da Varejo Integrado aos Usu&aacute;rios, mas apenas como
            autoriza&ccedil;&atilde;o de uso prec&aacute;rio da Plataforma, bem
            como de suas funcionalidades e ferramentas.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="3"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Aus&ecirc;ncia de interfer&ecirc;ncia no funcionamento da Plataforma
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . &Eacute; vedado aos Usu&aacute;rios utilizar quaisquer
            dispositivos, softwares, e/ou quaisquer outros recursos que possam
            interferir nas atividades e/ou opera&ccedil;&otilde;es da
            Plataforma. Qualquer interfer&ecirc;ncia, tentativa de
            interfer&ecirc;ncia, ou qualquer outra conduta que viole ou
            contrarie as normas vigentes de direitos autorais e/ou propriedade
            industrial e/ou as proibi&ccedil;&otilde;es existentes neste Termos
            de Uso, poder&aacute; acarretar a rescis&atilde;o deste Termos de
            Uso, suspens&atilde;o do cadastro do Usu&aacute;rio por tempo
            indeterminado ou, ainda, seu cancelamento, sem preju&iacute;zo de
            responsabiliza&ccedil;&atilde;o c&iacute;vel e criminal do
            Usu&aacute;rio, bem como do pagamento de indeniza&ccedil;&atilde;o
            por perdas e danos eventualmente incorridos, al&eacute;m da
            n&atilde;o devolu&ccedil;&atilde;o dos valores eventualmente
            j&aacute; pagos.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="4"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Uso de imagens, marcas, logos e sinais distintivos dos
            Usu&aacute;rios
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Os Usu&aacute;rios desde j&aacute; autorizam, por prazo
            indeterminado e a t&iacute;tulo gratuito, a Varejo Integrado a
            utilizar as imagens, marcas, logos e sinais distintivos dos
            Usu&aacute;rios e de seus produtos e lojas no &acirc;mbito da
            Plataforma e para a promo&ccedil;&atilde;o da Plataforma. Os
            Usu&aacute;rios se obrigam a apenas utilizar marcas, logos e sinais
            distintivos que sejam de sua propriedade ou que estejam devidamente
            licenciados. Em caso de reclama&ccedil;&atilde;o de terceiros, a
            Varejo Integrado se reserva o direito de imediatamente suspender a
            divulga&ccedil;&atilde;o de eventuais imagens, marcas, logos e
            sinais distintivos que estejam sendo objeto de questionamento.
            Ressalvado o disposto acima, a celebra&ccedil;&atilde;o deste Termos
            de Uso n&atilde;o transfere qualquer direito de propriedade
            intelectual dos Usu&aacute;rios &agrave; Varejo Integrado. Todos os
            direitos de propriedade intelectual dos Usu&aacute;rios continuam a
            ser de &uacute;nica e exclusiva propriedade dos Usu&aacute;rios.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="5"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Responsabilidade sobre informa&ccedil;&otilde;es e conte&uacute;dos
            inseridos na Plataforma
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Os Usu&aacute;rios s&atilde;o respons&aacute;veis por todas as
            informa&ccedil;&otilde;es enviadas por si ou por prepostos e
            intermedi&aacute;rios de seus colaboradores e representantes em
            geral aos servidores da Varejo Integrado atrav&eacute;s do acesso e
            uso da Plataforma, assim como por qualquer conte&uacute;do inserido
            na Plataforma, responsabilizando-se integralmente e ilimitadamente
            por quaisquer viola&ccedil;&otilde;es legais a direitos de
            terceiros, incluindo direitos de propriedade intelectual.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="8"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -18,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            POL&Iacute;TICA DE PRIVACIDADE
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Consentimento com o tratamento de dados pessoais
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Ao acessar a Plataforma e usar os servi&ccedil;os disponibilizados
            pela Varejo Integrado, os Usu&aacute;rios expressamente aderem
            &agrave; Pol&iacute;tica de Privacidade e consentem e autorizam a
            Varejo Integrado a realizar o tratamento de seus dados pessoais para
            as finalidades determinadas e previstas na Pol&iacute;tica de
            Privacidade e de acordo com os termos e condi&ccedil;&otilde;es
            detalhados neste instrumento e na Pol&iacute;tica de Privacidade. O
            consentimento do Usu&aacute;rio poder&aacute; ser revogado a
            qualquer tempo, de forma gratuita, devendo, neste caso, o
            Usu&aacute;rio entrar em contato com a equipe da Varejo Integrado
            por meio dos canais de comunica&ccedil;&atilde;o oficiais informados
            neste instrumento e na Pol&iacute;tica de Privacidade. A
            revoga&ccedil;&atilde;o do consentimento do Usu&aacute;rio
            implicar&aacute; a suspens&atilde;o ou o bloqueio de seu acesso
            &agrave; Plataforma, sem qualquer &ocirc;nus ou penalidade para a
            Varejo Integrado. A revoga&ccedil;&atilde;o do consentimento
            n&atilde;o ter&aacute; efeitos retroativos, sendo ratificados os
            tratamentos de dados pessoais realizados sob amparo do consentimento
            anteriormente manifestado pelo Usu&aacute;rio.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="9"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -18,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            INDENTIDADE E LIMITA&Ccedil;&Atilde;O DE RESPONSABILIDADE
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Indenidade
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Os Usu&aacute;rios obrigam-se a indenizar e a manter a Varejo
            Integrado, seus s&oacute;cios, administradores e colaboradores
            livres e totalmente indenes por quaisquer gastos, perdas, despesas,
            danos, reclama&ccedil;&otilde;es e/ou reivindica&ccedil;&otilde;es
            incorridos ou sofridos com rela&ccedil;&atilde;o ou em
            decorr&ecirc;ncia&nbsp;
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            (a)
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;de qualquer viola&ccedil;&atilde;o deste Termos de Uso por
            parte dos Usu&aacute;rios, de seus s&oacute;cios, administradores
            e/ou colaboradores; e&nbsp;
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            (b)
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;das atividades e neg&oacute;cios desenvolvidas pelos
            Usu&aacute;rios, e que venham a ser imputados &agrave; Varejo
            Integrado e/ou a seus s&oacute;cios, administradores e
            colaboradores, diretos ou indiretos, por qualquer raz&atilde;o, a
            qualquer tempo.&nbsp;
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="3"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: 18,
          paddingLeft: 7.2,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Compensa&ccedil;&atilde;o e reten&ccedil;&atilde;o autorizadas
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Ao utilizar a Plataforma, os Usu&aacute;rios autorizam, de forma
            expressa, irrevog&aacute;vel e irretrat&aacute;vel, que quaisquer
            valores certos, l&iacute;quidos e exig&iacute;veis devidos por si
            &agrave; Varejo Integrado poder&atilde;o ser retidos e compensados
            com quaisquer outros valores de sua titularidade que estejam sob
            posse ou dom&iacute;nio, ainda que prec&aacute;rio da Varejo
            Integrado, nos termos do C&oacute;digo Civil Brasileiro, arts. 368 e
            seguintes, especialmente, mas n&atilde;o se limitando a, pagamento
            de reembolsos, multas, juros, perdas e danos, d&eacute;bitos
            decorrentes de condena&ccedil;&otilde;es, custas e despesas
            processuais, al&eacute;m de honor&aacute;rios advocat&iacute;cios.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="2"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Limita&ccedil;&atilde;o de responsabilidade da Varejo Integrado
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Os Usu&aacute;rios reconhecem e aceitam que a Varejo Integrado
            n&atilde;o &eacute; e n&atilde;o ser&aacute; respons&aacute;vel:
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            por qualquer acesso indevido, atividade suspeita na conta do
            Usu&aacute;rio ou, ainda, pelas eventuais consequ&ecirc;ncias e
            danos decorrentes da falha do Usu&aacute;rio em manter a
            confidencialidade da senha e/ou da falta ou atraso na
            comunica&ccedil;&atilde;o &agrave; Varejo Integrado referente a
            eventual acesso indevido ou uso n&atilde;o autorizado da senha do
            Usu&aacute;rio por terceiros;
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="2"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            por quaisquer atos ou fatos decorrentes de for&ccedil;a maior ou
            caso fortuito, incluindo, mas n&atilde;o se limitando,
            &agrave;queles casos em que o cumprimento de
            obriga&ccedil;&otilde;es aqui previstas se tornar invi&aacute;vel
            por consequ&ecirc;ncia direta ou indireta de suspens&atilde;o de
            servi&ccedil;os de terceiros (como eletricidade, telefonia ou
            internet), inc&ecirc;ndios, tempestade, lei, regulamento, greves,
            pandemias, insurrei&ccedil;&atilde;o ou revolta, guerra, ou qualquer
            outra causa que for inevit&aacute;vel ou al&eacute;m do controle
            razo&aacute;vel da Varejo Integrado;
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="3"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            por eventuais perdas e danos causados por falhas na Plataforma, no
            servidor, na internet e por quaisquer intera&ccedil;&otilde;es ou
            ataques de v&iacute;rus ou outras rotinas de
            programa&ccedil;&atilde;o de computador que possam afetar o uso e a
            disponibilidade da Plataforma;
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="4"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            por eventuais perdas e danos causados em raz&atilde;o da entrega de
            produtos avariados, danificados ou em desconformidade com as
            caracter&iacute;sticas anunciadas pelos Atacadistas;
          </span>
        </p>
      </li>
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            por qualquer dano sofrido pelo Usu&aacute;rio em virtude da
            remo&ccedil;&atilde;o unilateral de quaisquer dados e
            informa&ccedil;&otilde;es que inseriu na Plataforma, do cancelamento
            do seu cadastro, bem como da preserva&ccedil;&atilde;o ou
            fornecimento de informa&ccedil;&otilde;es a seu respeito, incluindo
            aquelas relativas &agrave; sua identifica&ccedil;&atilde;o,
            localiza&ccedil;&atilde;o e registros de conex&atilde;o e/ou de
            acesso &agrave; Plataforma, desde que em cumprimento destes Termos
            de Uso, da Pol&iacute;tica de Privacidade e/ou de ordens judiciais
            ou administrativas;
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="6"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            por eventual modifica&ccedil;&atilde;o, suspens&atilde;o,
            interrup&ccedil;&atilde;o ou descontinua&ccedil;&atilde;o da
            Plataforma;
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="7"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            por qualquer declara&ccedil;&atilde;o ou garantia, expressa ou
            impl&iacute;cita ou realizada atrav&eacute;s de
            negocia&ccedil;&otilde;es com os Usu&aacute;rios, incluindo, mas sem
            limita&ccedil;&atilde;o: (i) &agrave; garantia impl&iacute;cita de
            adequa&ccedil;&atilde;o a um determinado fim ou &agrave;
            n&atilde;o-viola&ccedil;&atilde;o de direitos de terceiros; e (ii) a
            qualquer garantia com rela&ccedil;&atilde;o &agrave; qualidade,
            precis&atilde;o, efic&aacute;cia, tempestividade ou integralidade
            dos servi&ccedil;os oferecidos a partir da Plataforma, ou de que o
            acesso do Usu&aacute;rio ou o uso pelo Usu&aacute;rio dos
            servi&ccedil;os da Plataforma ser&atilde;o livres de erros, de
            v&iacute;rus, de falhas, ininterruptos ou atender&atilde;o a todos
            os requisitos do Usu&aacute;rio;
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="8"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            por eventuais preju&iacute;zos decorrentes de lucros cessantes, dano
            moral, dano indireto, dano emergente, dano &agrave; imagem, perda de
            oportunidade comercial e quebra de expectativa; e
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="9"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "lower-alpha",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -4.9,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            por qualquer ato, fato ou evento que n&atilde;o acarrete ao
            Usu&aacute;rio o dever de realizar um desembolso efetivo de
            recursos.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="3"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: 10.35,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Limite m&aacute;ximo de indeniza&ccedil;&atilde;o
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Nas hip&oacute;teses em que a Varejo Integrado seja considerada
            respons&aacute;vel por danos comprovadamente causados pela
            Plataforma, a indeniza&ccedil;&atilde;o devida estar&aacute;
            limitada:&nbsp;
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            (a)
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;no caso de indeniza&ccedil;&atilde;o devida a um Atacadista,
            &agrave; quantia correspondente ao valor total recebido de tal
            Atacadista a t&iacute;tulo de comiss&atilde;o de venda de produtos
            nos 3 (tr&ecirc;s) meses imediatamente anteriores ao evento que
            gerou a indeniza&ccedil;&atilde;o; e&nbsp;
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            (b)
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;no caso de indeniza&ccedil;&atilde;o devida a um Mercado,
            &agrave; quantia correspondente a 20% do valor total das compras
            realizadas por tal Mercado nos 3 (tr&ecirc;s) meses imediatamente
            anteriores ao evento que gerou a indeniza&ccedil;&atilde;o. Os
            Usu&aacute;rios declaram estar de acordo com esta cl&aacute;usula de
            limita&ccedil;&atilde;o quantitativa da responsabilidade da Varejo
            Integrado. Caso o Usu&aacute;rio n&atilde;o esteja de acordo com
            esta limita&ccedil;&atilde;o, dever&aacute; interromper a
            utiliza&ccedil;&atilde;o da Plataforma imediatamente.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="10"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -18,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            PRE&Ccedil;O E PAGAMENTO
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Comiss&atilde;o
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Em contrapartida ao uso da Plataforma, os Atacadistas devem pagar
            &agrave; Varejo Integrado uma comiss&atilde;o calculada sobre o
            valor total bruto das vendas de produtos realizadas por meio da
            Plataforma ou em raz&atilde;o da presta&ccedil;&atilde;o de
            servi&ccedil;os de intermedia&ccedil;&atilde;o de neg&oacute;cios
            pela Varejo Integrado. O valor da comiss&atilde;o, a forma de
            apura&ccedil;&atilde;o, o prazo de pagamento e demais
            condi&ccedil;&otilde;es comerciais s&atilde;o estabelecidas e
            definidas no momento em que o Atacadista adere &agrave; Plataforma,
            por meio do formul&aacute;rio de cadastro.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="2"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Uso gratuito da Plataforma pelos Mercados
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . O Uso da Plataforma pelos Mercados &eacute; gratuito, e nenhuma
            comiss&atilde;o, taxa ou pre&ccedil;o ser&aacute; cobrado dos
            Mercados pela simples utiliza&ccedil;&atilde;o da Plataforma. Em
            caso de contrata&ccedil;&atilde;o de servi&ccedil;os ou
            funcionalidades adicionais e espec&iacute;ficas, a Varejo Integrado
            se reserva o direito de realizar a cobran&ccedil;a da devida
            compensa&ccedil;&atilde;o, sempre mediante aviso pr&eacute;vio e
            obten&ccedil;&atilde;o de consentimento por escrito dos Mercados.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="3"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: 18,
          paddingLeft: 7.2,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Cobran&ccedil;a de reembolsos
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Nos casos de adiantamento de quaisquer valores pela Varejo
            Integrado para aquisi&ccedil;&atilde;o dos pedidos dos Mercados,
            poder&aacute; ser requerida a assinatura, ainda que
            eletr&ocirc;nica, de documento de confiss&atilde;o de d&iacute;vida
            no ato da entrega dos produtos, e, desde j&aacute;, o Mercado
            autoriza a Varejo Integrado a extrair t&iacute;tulo de
            cr&eacute;dito associado a esta entrega e proceder ao protesto dos
            valores reembols&aacute;veis assim que haja o inadimplemento,
            independente de pr&eacute;via interpela&ccedil;&atilde;o.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="2"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="3"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: 18,
          paddingLeft: 7.2,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Comprova&ccedil;&atilde;o eletr&ocirc;nica de autoria e integridade
            da assinatura
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . No ato da efetiva entrega dos bens, os documentos e t&iacute;tulos
            de cr&eacute;dito acima referidos poder&atilde;o ser assinados por
            quaisquer prepostos do Mercado, assumindo-se como comprovante
            v&aacute;lido e eficaz de autoria e integridade da assinatura dos
            documentos e t&iacute;tulos de cr&eacute;dito a coleta de simples
            visto, sinal ou aceite eletr&ocirc;nico pelo respons&aacute;vel do
            Mercado no local, independente das formalidades do ICP-Brasil, nos
            termos que autoriza a MP 2.220-2, art. 10, &sect; 2&ordm;.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="3"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Reajustes de pre&ccedil;os.
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;A Varejo Integrado se reserva o direito de unilateralmente
            reajustar os valores cobrados pelo uso da Plataforma. Os
            Usu&aacute;rios ser&atilde;o avisados sobre os novos pre&ccedil;os
            e, caso n&atilde;o concordem, poder&atilde;o optar por cancelar o
            uso e o acesso &agrave; Plataforma. Em qualquer hip&oacute;tese, o
            uso continuado da Plataforma implicar&aacute;
            aceita&ccedil;&atilde;o t&aacute;cita dos reajustes de
            pre&ccedil;os, sem ressalvas. A contrata&ccedil;&atilde;o da
            Plataforma n&atilde;o garante aos Usu&aacute;rios o direito ao
            pre&ccedil;o inicialmente contratado por tempo indeterminado,
            estando sujeito &agrave;s mudan&ccedil;as de valores e
            funcionalidades eventualmente promovidos pela Varejo Integrado.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="4"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Atraso no pagamento
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Em caso de atraso no pagamento, o Usu&aacute;rio ficar&aacute;
            sujeito ao pagamento das penalidades previstas na Cl&aacute;usula
            12.2. Adicionalmente, a Varejo Integrado se reserva o direito de
            cancelar ou interromper o acesso &agrave; Plataforma do
            Usu&aacute;rio inadimplente, sem a necessidade de pr&eacute;vio
            aviso.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="11"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -18,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            VIG&Ecirc;NCIA E T&Eacute;RMINO
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Regras de in&iacute;cio e ratifica&ccedil;&atilde;o de
            vig&ecirc;ncia
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Este Termos de Uso entra em vigor: (i) no momento em que o Mercado
            realizar na Plataforma, pela primeira vez, um pedido de fornecimento
            de bens ou servi&ccedil;os, ou o Atacadista publicar na Plataforma a
            disponibilidade de um produto a um determinado pre&ccedil;o, (ii) na
            data em que o Usu&aacute;rio beneficiar-se de qualquer utilidade ou
            solicitar, pela primeira vez, um dos servi&ccedil;os prestados pela
            Varejo Integrado, (iii) na data em que houver a
            manifesta&ccedil;&atilde;o da vontade de aceita&ccedil;&atilde;o
            pelo Usu&aacute;rio, que poder&aacute; ser comprovada por qualquer
            forma, inclusive por meio eletr&ocirc;nico, ou (iv) em casos de
            ratifica&ccedil;&atilde;o da vig&ecirc;ncia, pelo uso continuado da
            Plataforma ap&oacute;s qualquer altera&ccedil;&atilde;o. Em todas as
            hip&oacute;teses, este Termos de Uso permanecer&aacute; em vigor por
            tempo indeterminado, at&eacute; que seja rescindido ou encerrado por
            qualquer das partes.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="2"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Rescis&atilde;o imotivada
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Este Termos de Uso poder&aacute; ser rescindido imotivadamente por
            qualquer das partes a qualquer tempo, sem qualquer &ocirc;nus ou
            penalidade, mediante simples envio de comunica&ccedil;&atilde;o a
            outra parte, devendo o Usu&aacute;rio quitar todos os encargos
            eventualmente devidos e ainda n&atilde;o pagos no momento do
            t&eacute;rmino. O cancelamento antecipado por parte do
            Usu&aacute;rio n&atilde;o obriga a Varejo Integrado a reembolsar
            eventuais valores pagos antecipadamente pelo Usu&aacute;rio.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="3"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Rescis&atilde;o motivada
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Qualquer das partes poder&aacute; rescindir este Termos de Uso,
            mediante envio de simples comunica&ccedil;&atilde;o, na
            hip&oacute;tese de descumprimento deste Termos de Uso ou da
            legisla&ccedil;&atilde;o aplic&aacute;vel, n&atilde;o sanado no
            prazo espec&iacute;fico ou, caso n&atilde;o haja prazo
            espec&iacute;fico e seja poss&iacute;vel sanar o descumprimento, no
            prazo de 5 (cinco) dias corridos ap&oacute;s o recebimento de
            comunica&ccedil;&atilde;o a esse respeito. Neste caso, a parte
            inocente ter&aacute; o direito de cobrar da parte infratora
            indeniza&ccedil;&atilde;o por todas as perdas e danos eventualmente
            sofridos, observadas as limita&ccedil;&otilde;es previstas neste
            instrumento.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="4"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Efeitos do encerramento ou cancelamento do uso da Plataforma
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Em caso de encerramento ou cancelamento do uso da Plataforma, por
            qualquer raz&atilde;o, dever&aacute; ser observado o seguinte: (a) o
            acesso &agrave;s funcionalidades da Plataforma ser&aacute;
            interrompido e bloqueado; e (b) a Varejo Integrado poder&aacute;
            excluir todos os arquivos, dados e informa&ccedil;&otilde;es
            armazenados em seus servidores, tendo sido extra&iacute;das ou
            n&atilde;o pelo Usu&aacute;rio antes do cancelamento ou encerramento
            do uso da Plataforma, observado o disposto na Pol&iacute;tica de
            Privacidade.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="12"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="1"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -18,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            DISPOSI&Ccedil;&Otilde;ES GERAIS
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}>
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Viola&ccedil;&atilde;o dos Termos de Uso ou da
            legisla&ccedil;&atilde;o vigente
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . No caso de descumprimento, pelo Usu&aacute;rio, de qualquer
            disposi&ccedil;&atilde;o deste Termos de Uso ou da
            legisla&ccedil;&atilde;o vigente, a Varejo Integrado poder&aacute;,
            independentemente de qualquer aviso, notifica&ccedil;&atilde;o ou de
            qualquer outra formalidade, interromper, suspender ou cancelar, de
            imediato, tempor&aacute;ria ou definitivamente, a conta e o acesso
            do Usu&aacute;rio &agrave; Plataforma, sem preju&iacute;zo de
            quaisquer outros direitos assegurados &agrave; Varejo Integrado por
            lei, pelos Termos de Uso e/ou pela Pol&iacute;tica de Privacidade,
            nada podendo ser reclamado ou cobrado da Varejo Integrado a esse
            respeito.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="2"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Atraso no pagamento
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . O atraso no pagamento de qualquer obriga&ccedil;&atilde;o prevista
            neste Termos de Uso sujeitar&aacute; os valores devidos e n&atilde;o
            pagos &agrave; incid&ecirc;ncia de juros no valor de 1% (um cento)
            ao m&ecirc;s, multa de 2% (dois por cento) e corre&ccedil;&atilde;o
            monet&aacute;ria positiva segundo IPCA/IBGE, ou outro que o venha
            substituir, caso seja extinto, aplicado &ldquo;pro rata dies&rdquo;
            desde a data do inadimplemento at&eacute; o efetivo pagamento dos
            referidos valores.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="3"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Independ&ecirc;ncia das partes
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Este Termos de Uso n&atilde;o estabelece qualquer forma de
            associa&ccedil;&atilde;o, franquia, parceria, cons&oacute;rcio,
            joint-venture, mandato, v&iacute;nculo empregat&iacute;cio,
            societ&aacute;rio ou solidariedade, tampouco confere &agrave;s
            partes autoriza&ccedil;&atilde;o para praticar quaisquer atos,
            representar, contratar ou assumir obriga&ccedil;&otilde;es em nome
            da outra parte.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="4"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Revis&otilde;es ou atualiza&ccedil;&otilde;es
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . A Varejo Integrado poder&aacute; alterar, a qualquer tempo, este
            Termos de Uso. Fica estabelecido que as novas vers&otilde;es dos
            Termos de Uso entrar&atilde;o em vigor, por aceita&ccedil;&atilde;o
            t&aacute;cita, na data do primeiro uso da Plataforma pelo
            Usu&aacute;rio ap&oacute;s sua publica&ccedil;&atilde;o, sendo que o
            Usu&aacute;rio somente poder&aacute; continuar a utilizar a
            Plataforma caso concorde, ou n&atilde;o discorde expressamente com
            as referidas altera&ccedil;&otilde;es. O Usu&aacute;rio
            poder&aacute;, caso n&atilde;o concorde com a referida nova
            vers&atilde;o, extinguir o seu cadastro da Plataforma (&ldquo;
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "italic",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Opt.Out
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &rdquo;). Nessa hip&oacute;tese, o v&iacute;nculo contratual
            deixar&aacute; de existir, a crit&eacute;rio exclusivo do
            Usu&aacute;rio, sem qualquer penalidade ao Usu&aacute;rio ou
            &agrave; Varejo Integrado. Em qualquer hip&oacute;tese, o uso da
            Plataforma, ap&oacute;s o Usu&aacute;rio ter sido comunicado a
            respeito das altera&ccedil;&otilde;es, ser&aacute; considerado como
            aceite da nova vers&atilde;o deste Termos de Uso, nos termos do
            C&oacute;digo Civil Brasileiro, art. 111.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="5"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Acordo integral
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Este Termos de Uso supera, substitui e prevalece sobre qualquer
            acordo ou contrato pr&eacute;vio, escrito ou verbal, que tenha sido
            levado a efeito pelas partes com rela&ccedil;&atilde;o aos assuntos
            aqui contemplados. Para que n&atilde;o restem d&uacute;vidas, este
            Termos de Uso n&atilde;o substitui a Pol&iacute;tica de Privacidade.
            Tais documentos devem ser sempre lidos em conjunto e em caso de
            conflito entre suas disposi&ccedil;&otilde;es dever&aacute;
            prevalecer a regra mais espec&iacute;fica.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="6"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Sucessores
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Este Termos de Uso vincula o Usu&aacute;rio e a Varejo Integrado
            ao seu fiel cumprimento, bem como seus sucessores a qualquer
            t&iacute;tulo, em car&aacute;ter irrevog&aacute;vel e
            irretrat&aacute;vel.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="7"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Necessidade de ren&uacute;ncia expressa e escrita e princ&iacute;pio
            da conserva&ccedil;&atilde;o
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . A Varejo Integrado e os Usu&aacute;rios declaram e acordam
            expressamente que:&nbsp;
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            (a)
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;o n&atilde;o exerc&iacute;cio ou o atraso no exerc&iacute;cio
            de qualquer direito que lhes seja assegurado por este instrumento ou
            por lei n&atilde;o constituir&aacute; nova&ccedil;&atilde;o ou
            ren&uacute;ncia a tal direito, nem prejudicar&aacute; o eventual
            exerc&iacute;cio do mesmo;&nbsp;
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            (b)
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;a ren&uacute;ncia a qualquer desses direitos somente
            ser&aacute; v&aacute;lida se formalizada por escrito, se e quando
            tal ren&uacute;ncia n&atilde;o for vedada por lei; e&nbsp;
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            (c)
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;a nulidade ou invalidade de qualquer das cl&aacute;usulas
            deste instrumento n&atilde;o prejudicar&aacute; a validade e
            efic&aacute;cia das demais cl&aacute;usulas. Caso seja decretada a
            nulidade, anulabilidade ou inefic&aacute;cia de qualquer das
            cl&aacute;usulas deste instrumento, a Varejo Integrado tomar&aacute;
            todas as provid&ecirc;ncias, inclusive por meio da
            altera&ccedil;&atilde;o deste instrumento, para que, em conformidade
            com a legisla&ccedil;&atilde;o em vigor, seja alcan&ccedil;ado, na
            maior extens&atilde;o poss&iacute;vel, o resultado pr&aacute;tico a
            que visava este instrumento com a(s) cl&aacute;usula(s)
            inquinada(s).
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="8"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            T&iacute;tulos
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Os t&iacute;tulos das cl&aacute;usulas ou cap&iacute;tulos deste
            Termos de Uso s&atilde;o meramente ilustrativos, e foram inseridos
            para facilitar a compreens&atilde;o do Usu&aacute;rio.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="9"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Notifica&ccedil;&otilde;es
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Todos os avisos e notifica&ccedil;&otilde;es relacionados a este
            Termos de Uso dever&atilde;o ser feitos por escrito, sendo
            encaminhados,&nbsp;
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            (a)
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;se para a Varejo Integrado, para o endere&ccedil;o de e-mail
            meajuda@mercedobairro.com ou para o seu endere&ccedil;o
            f&iacute;sico, localizado no Munic&iacute;pio de S&atilde;o Paulo,
            no Estado de S&atilde;o Paulo, na Avenida Brigadeiro Faria Lima,
            n.&ordm; 2232, apartamento 16-A, Edif&iacute;cio Dijon, Jardim
            Paulistano, CEP 01489-900 e,&nbsp;
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 700,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            (b)
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            &nbsp;se para o Usu&aacute;rio, ao endere&ccedil;o f&iacute;sico ou
            eletr&ocirc;nico constante de seu cadastro na Plataforma e/ou por
            meio de alertas na &aacute;rea dos Usu&aacute;rios da Plataforma. Os
            referidos avisos e notifica&ccedil;&otilde;es ter&atilde;o validade
            se enviados por escrito e por qualquer meio que permita comprovar o
            respectivo recebimento.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="10"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Tributos
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Os tributos devidos direta ou indiretamente em decorr&ecirc;ncia
            da execu&ccedil;&atilde;o deste Termos de Uso e do uso da
            Plataforma, existentes e/ou que venham a ser criados, bem como as
            respectivas majora&ccedil;&otilde;es, mudan&ccedil;as de base de
            c&aacute;lculo e/ou do per&iacute;odo de apura&ccedil;&atilde;o,
            reajustes, encargos morat&oacute;rios e/ou obriga&ccedil;&otilde;es
            tribut&aacute;rias acess&oacute;rias, constituem &ocirc;nus de
            responsabilidade do respectivo sujeito passivo da
            obriga&ccedil;&atilde;o tribut&aacute;ria, conforme definido na
            legisla&ccedil;&atilde;o vigente.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="11"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Legisla&ccedil;&atilde;o aplic&aacute;vel
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . O Usu&aacute;rio declara-se ciente e concorda que,
            independentemente do local de onde esteja utilizando a Plataforma,
            este Termos de Uso &eacute; regido pelas leis brasileiras.
          </span>
        </p>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <ol
      start="12"
      style={{ marginTop: 0, marginBottom: 0, paddingInlineStart: 48 }}
    >
      <li
        aria-level="2"
        data-darkreader-inline-bgcolor=""
        data-darkreader-inline-color=""
        dir="ltr"
        style={{
          listStyleType: "decimal",
          fontSize: 10,
          fontFamily: "Arial",
          color: "rgb(0, 0, 0)",
          backgroundColor: "transparent",
          fontWeight: 400,
          fontStyle: "normal",
          fontVariant: "normal",
          textDecoration: "none",
          verticalAlign: "baseline",
          whiteSpace: "pre",
          marginLeft: -3.8,
        }}
      >
        <p
          dir="ltr"
          style={{
            lineHeight: 1.7999999999999998,
            textAlign: "justify",
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "underline",
              textDecorationSkipInk: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            Foro
          </span>
          <span
            data-darkreader-inline-bgcolor=""
            data-darkreader-inline-color=""
            style={{
              fontSize: 10,
              fontFamily: "Arial",
              color: "rgb(0, 0, 0)",
              backgroundColor: "transparent",
              fontWeight: 400,
              fontStyle: "normal",
              fontVariant: "normal",
              textDecoration: "none",
              verticalAlign: "baseline",
              whiteSpace: "pre-wrap",
            }}
          >
            . Em caso de disputas ou desentendimentos a respeito deste Termos de
            Uso, fica eleito o Foro da Comarca de S&atilde;o Paulo, Estado de
            S&atilde;o Paulo, para dirimir quaisquer d&uacute;vidas ou
            controv&eacute;rsias, com a exclus&atilde;o de qualquer outro, por
            mais privilegiado que seja ou venha a ser.
          </span>
        </p>
      </li>
    </ol>
  </>
)

export default Terms
